import 'leaflet/dist/leaflet.css';
import './scss/main.scss';
import Vue from 'vue';
import App from './App.vue';
import { Icon } from 'leaflet';
import { store } from './store.js';

import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';
import HighchartsMore from 'highcharts/highcharts-more';
import ExportingHighcharts from "highcharts/modules/exporting";
HighchartsMore(Highcharts)
ExportingHighcharts(Highcharts);
Vue.use(HighchartsVue);

import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
Vue.use(Antd);

import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
Vue.use(BootstrapVue);

import Echo from 'laravel-echo';

window.Pusher=require('pusher-js');

window.Echo=new Echo({
  broadcaster: 'pusher',
  key: process.env.VUE_APP_WEBSOCKETS_KEY,
  wsHost: process.env.VUE_APP_WEBSOCKETS_SERVER,
  wsPort: process.env.VUE_APP_WEBSOCKETS_PORT,
  forceTLS: !!+process.env.VUE_APP_WEBSOCKETS_FORCETLS,
  disableStats: true,
  enabledTransports: ["ws","wss"]
});

new Vue({
  store,
  render: h => h(App)
}).$mount('#app');

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

